"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteApi = exports.updateApi = exports.createApi = exports.fetchApi = exports.fetchApis = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxBatchedActions = require("redux-batched-actions");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _actions2 = require("../actions");

var _rest = require("../rest");

var _actions3 = require("./actions");

var _constants = require("../constants");

var _utils = require("../utils");

var _utils2 = require("../permissions/utils");

var _apisI18n = require("./apis-i18n");

var _messagesI18n = require("../messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NORMAL = _constants.STATES.NORMAL,
    LOADING = _constants.STATES.LOADING;

var fetchApis = function fetchApis(pageSize, pageNumber, _) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _yield$getApisApi, _yield$getApisApi$rec, apis, listConfig;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _actions3.changeListApisState)(LOADING));
              _context.next = 4;
              return (0, _rest.getApisApi)(pageSize, pageNumber);

            case 4:
              _yield$getApisApi = _context.sent;
              _yield$getApisApi$rec = _yield$getApisApi.records;
              apis = _yield$getApisApi$rec === void 0 ? [] : _yield$getApisApi$rec;
              listConfig = (0, _objectWithoutProperties2.default)(_yield$getApisApi, ["records"]);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeListApisState)(NORMAL), (0, _actions3.setApis)(apis.map(function (api) {
                return _objectSpread(_objectSpread({}, api), {}, {
                  tempId: api.id
                });
              })), (0, _actions3.changeApiListConfig)(listConfig)]));
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              dispatch((0, _actions3.changeListApisState)(NORMAL)); // todo handle errors

              console.log(_context.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_apisI18n.messages.errorDuringApisFetch)
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchApis = fetchApis;

var fetchApi = function fetchApi(apiId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      var api, beforeLoad, normalizedApi;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch((0, _actions3.changeUpdateApiState)(LOADING));
              _context2.next = 4;
              return (0, _rest.getApiApi)(apiId);

            case 4:
              api = _context2.sent;
              beforeLoad = [{
                name: 'permissions',
                normalize: _utils.convertToEditableList
              }, {
                name: 'claims',
                normalize: _utils.convertToEditableList
              }];
              normalizedApi = (0, _utils.applyNormalizedFunctions)(api, beforeLoad);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeUpdateApiState)(NORMAL), (0, _actions3.loadApiToUpdate)(_objectSpread(_objectSpread({}, normalizedApi), {}, {
                tempId: normalizedApi.id
              }))]));
              _context2.next = 15;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              dispatch((0, _actions3.changeUpdateApiState)(NORMAL)); // todo handle errors

              console.log(_context2.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _apisI18n.messages.errorDuringApisFetch
              }));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.fetchApi = fetchApi;

var createApi = function createApi(api, _ref3, _) {
  var pageSize = _ref3.pageSize,
      pageNumber = _ref3.pageNumber;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _actions3.changeCreateApiState)(LOADING));
              _context3.next = 4;
              return (0, _rest.createApiApi)(api);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeCreateApiState)(NORMAL), (0, _actions3.clearCreateApiParams)(), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_apisI18n.messages.apiSuccessfullyCreated)
              }));
              dispatch(fetchApis(pageSize, pageNumber, _));
              dispatch((0, _utils2.fetchPermissions)());
              _context3.next = 20;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _actions3.changeCreateApiState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context3.t0);
              _context3.t1 = errorCode;
              _context3.next = _context3.t1 === 409 ? 17 : 19;
              break;

            case 17:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _apisI18n.messages.apiAlreadyExists
              }));
              return _context3.abrupt("break", 20);

            case 19:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _apisI18n.messages.errorDuringApiCreation
              }));

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.createApi = createApi;

var updateApi = function updateApi(api, _ref5, _) {
  var pageSize = _ref5.pageSize,
      pageNumber = _ref5.pageNumber;
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              dispatch((0, _actions3.changeUpdateApiState)(LOADING));
              _context4.next = 4;
              return (0, _rest.updateApiApi)(api);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeLoadedApiTempId)(api.id), (0, _actions3.changeUpdateApiState)(NORMAL), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_apisI18n.messages.apiSuccessfullyUpdated)
              }));
              dispatch(fetchApis(pageSize, pageNumber, _));
              dispatch((0, _utils2.fetchPermissions)());
              _context4.next = 20;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              dispatch((0, _actions3.changeUpdateApiState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context4.t0);
              _context4.t1 = errorCode;
              _context4.next = _context4.t1 === 409 ? 17 : 19;
              break;

            case 17:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _apisI18n.messages.apiAlreadyExists
              }));
              return _context4.abrupt("break", 20);

            case 19:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _apisI18n.messages.errorDuringApiUpdate
              }));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.updateApi = updateApi;

var deleteApi = function deleteApi(id, _ref7, _) {
  var pageSize = _ref7.pageSize,
      pageNumber = _ref7.pageNumber;
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _rest.deleteApiApi)(id);

            case 3:
              dispatch((0, _actions3.clearAllApiForms)());
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_apisI18n.messages.apiSuccessfullyDeleted)
              }));
              dispatch(fetchApis(pageSize, pageNumber, _));
              dispatch((0, _utils2.fetchPermissions)());
              _context5.next = 13;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              // todo handle errors
              console.log(_context5.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_apisI18n.messages.errorDuringApiDeletion)
              }));

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.deleteApi = deleteApi;
//# sourceMappingURL=utils.js.map